
@if(isActiveSettingBudget){  
    <app-setting-budget (closeSettingBudget)="closeSettingBudget($event)"
    [isNewBudget]="isNewBudget" [year]="filter.year" [version]="filter.version"
    [isReadOnly]="isReadOnlyBudget"
    ></app-setting-budget>
  }


@if(!isActiveSettingBudget){
<div class="row">
    <div class="col-12 col-md-6">
        <h1 class="page-header"><i class="fa-solid fa-square-poll-vertical"></i> Presupuesto </h1>
    </div>

    <div class="col-12 col-md-6 mt-3">
        <div class="mb-3 d-md-flex justify-content-end fw-bold align-items-center gap-3" [appHasRole]="appHasAccess">
            <div class="mt-md-0 mt-2">
                <a href="javascript:;" (click)="syncWithAasinet()" class="text-decoration-none text-dark" title="Sincronizar entidad seleccionada">
                    <i class="fa fa-sync fa-fw me-1 text-dark text-opacity-50"></i> Sincronizar con Aasinet
                </a>
            </div>
        </div>
    </div>
</div>
<div class="panel " data-sortable-id="ui-widget-16">
    <div class="panel-heading ">
    </div>
    <div class="panel-body p-4 pt-3">
        <div class="row">
            <div class="row mb-3 align-items-center">
                <div class="col-12 col-md-12 d-flex justify-content-end">
                    <button  [appHasRole]="appHasAccess" class="btn btn-success text-white btn-sm " (click)="openModalBudget()">Nuevo
                        Presupuesto</button>
                </div>
            </div>

            <div class="">
                <div class="table-data">
                    <table class="table table-striped table-sm ">
                        <thead>
                            <tr class="sticky-column">
                                <th style="width: 35px;">Fijar</th>
                                <th>Presupuesto</th>
                                <th>Descripción</th>
                                <th>Fecha actualización</th>
                                <th class="text-center">Estado</th>
                                @if(permissionService.canAccess()){
                                <th class="text-center"><span class="d-flex justify-content-center"><i class="fa fa-cogs"></i></span></th>
                                }
                            </tr>
                        </thead>
                        @if(budget?.length>0){
                        <tbody>
                            @for(d of budget;track $index; let idx = $index){
                            <tr>
                                <td class="text-center">
                                    @if(!isBudgetSelected(d)){
                                    <button type="button" class="btn btn-outline-gray btn-xs" ngbTooltip="Seleccionar Presupuesto" placement="right" 
                                    (click)="selectBudget(d)"><i class="fas" [ngClass]="loadingId === d.id ? 'fa-spinner fa-spin' : 'fa-thumbtack'"></i></button>
                                    } @else {
                                    <span class="badge bg-success rounded" ngbTooltip="Presupuesto activo" placement="right"><i class="fas fa-check text-white"></i></span>
                                    }
                                </td>
                                        
                                <td>{{d.year+'-'+d.version}}</td>
                                <td>{{d.name}}</td>
                                <td>{{d.updatedAt|date:'dd/MM/yyyy HH:mm'}}</td>
                                <td class="text-center"><span
                                        class="badge border fs-12px pb-5px pt-5px px-2 rounded d-inline-flex align-items-center"
                                        [ngClass]="d.budgetStatusStyle">
                                        <i
                                            class=" fas fa-circle fs-9px fa-fw me-5px "></i>{{d.budgetStatusName}}</span>
                                </td>
                                @if(permissionService.canAccess()){
                                <td>
<div ngbDropdown container="body">
  <button ngbDropdownToggle type="button" class="btn btn-outline-gray btn-xs">
    &nbsp;<i class="fas fa-ellipsis-v"></i>&nbsp;
  </button>

  <div ngbDropdownMenu>
     <button ngbDropdownItem (click)="openModalCloneBudget(d)"><i class="fas fa-copy me-2"></i>Clonar</button>
         @if (d.status == 2) {
      <button ngbDropdownItem (click)="setFormBudget(d)"><i class="fas fa-pencil-alt me-2"></i>Editar</button>
    } @else {
      <button ngbDropdownItem (click)="setFormBudget(d)"><i class="fas fa-eye me-2"></i>Ver</button>
    }
    
    @if (d.status == 2 && permissionService.canAccess()) {
        <div role="separator" class="dropdown-divider"></div>
      <button ngbDropdownItem (click)="deleteBudget(d)"><i class="fas fa-trash me-2"></i>Eliminar</button>
    }
  </div>
</div>

                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="6">{{budget?.length}} en Total</th>
                            </tr>
                        </tfoot>
                        }
                    </table>
                    @if(budget?.length===0){
                    <div class="m-l-10 mb-2">
                        <em>Sin registros</em>
                    </div>
                    }
                </div>
            </div>


        </div>
    </div>
</div>
}


    <!--modal diverse-->

    <ng-template #modal_budget let-c="close" let-d="dismiss" let-modal>

        <div class="modal-header">
            <h5 class="modal-title">{{modalHeaderBudget}}</h5>
            <span (click)="d('Cross click');isNewBudget=false;budgetFinded=false" type="button"
                class="btn-close bt-xs" data-dismiss="modal" tabindex="8">

            </span>
        </div>
        <div class="modal-body">
            <div class="panel-body panel-form">
                <form [formGroup]="formBudget">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Año</label>
                        <div class="col-md-8">
                            <input class="form-control" type="number" min="{{year}}" max="{{year+1}}" step="1"
                            [class.is-invalid]="formBudget.get('year').invalid&&formBudget.get('year').touched"
                            (keydown)="blockTyping($event)"
                            formControlName="year" (change)="findBudgetVersion()">
                            @if(formBudget.get('year')?.errors?.required && formBudget.get('year').touched){
                            <div><small class="text-danger">Año es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Descripción</label>
                        <div class="col-md-8">
                            <input type="text"  class="form-control" 
                                [class.is-invalid]="formBudget.get('name').invalid&&formBudget.get('name').touched"
                                (click)="formBudget.get('name').markAsUntouched();"
                                (focus)="formBudget.get('name').markAsUntouched();" formControlName="name"
                                name="name" class="form-control" tabindex="2" />
                            @if(formBudget.get('name')?.errors?.required && formBudget.get('name').touched){
                            <div><small class="text-danger">Descripción es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;  
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Fondo</label>
                        <div class="col-md-8">
                            <ng-select [class.is-invalid]="formBudget.get('fundCode').invalid&&formBudget.get('fundCode').touched"  [items]="aasinetFundSelect" [closeOnSelect]="false" formControlName="fundCode" name="fundCode" [hideSelected]="true"
                            [multiple]="true" bindLabel="nameCode" 
                           bindValue="code" >
                       </ng-select>
                        @if(formBudget.get('fundCode')?.errors?.required && formBudget.get('fundCode').touched){
                        <div><small class="text-danger">Fondo es requerido.</small></div>
                        }
                        @if(aasinetFundSelect?.length===0){
                            <div><small class="text-danger">No hay fondos disponibles. Sincroniza con Aasinet.</small></div>
                            }
                        </div>
                    </div>&nbsp;  
                    
                                   
                </form>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm"
                (click)="d('Cross click')"><i class="fas fa-times"></i>&nbsp;
                Cerrar</button>
            @if(modalHeaderBudget==='Nuevo Presupuesto'){
            <button type="button" class="btn btn-primary btn-sm"
                (click)="submitBudgetNew()"
                [disabled]="!formBudget.valid" tabindex="4"><i
                    class="fas fa-save"></i>&nbsp;Guardar</button>
            }
           
        </div>
    </ng-template>
    <!--end diverse-->

    <!-- Modal Clonar Presupuesto -->
    <ng-template #modal_clone_budget let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-copy me-2 text-primary"></i> Clonar Presupuesto</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="alert alert-info py-2 px-3 fs-13px mb-3">
                <i class="fas fa-info-circle me-1"></i> Permite clonar la estructura completa (fondos, departamentos, cuentas, empleados y valores presupuestados) de un presupuesto existente hacia un año nuevo o actual.
            </div>

            <form [formGroup]="formCloneBudget">
                <div class="mb-3">
                    <label class="form-label fw-bold">Presupuesto Origen (a clonar) <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="sourceBudgetId" (change)="onSourceBudgetChange($any($event.target).value)">
                        <option [value]="null" disabled>Seleccione un presupuesto...</option>
                        <option *ngFor="let b of budget" [value]="b.id">
                            {{ b.year }} - v{{ b.version }}: {{ b.name }} ({{ b.budgetStatusName || (b.status === 1 ? 'Votado/Cerrado' : 'En edición') }})
                        </option>
                    </select>
                    <small class="text-muted d-block mt-1">
                        Tip: Puedes seleccionar presupuestos de años ya cerrados o anteriores para utilizarlos como base.
                    </small>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Año Destino <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="targetYear" (change)="onTargetYearChange()" min="2000" max="2100" placeholder="Ej: {{ year }}">
                        @if(formCloneBudget.get('targetYear')?.invalid && formCloneBudget.get('targetYear')?.touched){
                            <div class="text-danger small mt-1">
                                Año destino requerido (mínimo 2000).
                            </div>
                        }
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Versión Origen</label>
                        <input type="text" class="form-control bg-light" [value]="sourceBudgetSelected ? 'Año ' + sourceBudgetSelected.year + ' - Versión ' + sourceBudgetSelected.version : 'Seleccione origen'" readonly>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label fw-bold">Descripción del Nuevo Presupuesto <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="name" placeholder="Nombre descriptivo para la nueva versión">
                    @if(formCloneBudget.get('name')?.invalid && formCloneBudget.get('name')?.touched){
                        <div class="text-danger small mt-1">
                            Descripción requerida (mínimo 3 caracteres).
                        </div>
                    }
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click')">
                <i class="fas fa-times me-1"></i> Cancelar
            </button>
            <button type="button" class="btn btn-primary btn-sm" (click)="submitCloneBudget()" [disabled]="formCloneBudget.invalid">
                <i class="fas fa-copy me-1"></i> Clonar Presupuesto
            </button>
        </div>
    </ng-template>